import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import dayjs from 'dayjs';
import * as _ from 'lodash';
import { PropTypes } from 'prop-types';
import CustomIcon from '../../../common/CustomIcon';
import * as taskActions from '../../../../actions/taskActions';
import * as drawerActions from '../../../../actions/drawerActions';
import * as bookActions from '../../../../actions/bookActions';
import * as assignmentsDrawerActions from '../../../../actions/assignmentsDrawerActions';
import CommentBox from '../../CommentBox';
import * as taskService from '../../../../services/domain/taskService';
import { getStudentAttemptData } from '../../../../types/task';
import ContentTaskContainer from '../ContentTaskContainer';
import PanelsBottomRowButton from '../../../common/PanelsBottomRowButton';
import { CMI5 } from '../../../../const';
import FileEvaluationBox from '../FileEvaluationBox';
import * as classroomActions from '../../../../actions/classroom/classroomActions';
import * as messageAlertActions from '../../../../actions/messageAlertAction';
import FirstEvaluationContainer from '../FirstEvaluationContainer';

class StudentTaskPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadingFile: false,
      responseFiles: [],
      changeComment: false,
      commentMessageText: ''
    };
  }

  componentDidMount() {
    this.mounted = true;

    const { taskActions, task, user, bookActions, classroom } = this.props;
    taskActions.setTaskContentsNotFound(false);
    taskActions.getSelectedTaskWithResults(task.id);
    taskActions.setEvaluatedAssignmentComments(user.id);
    bookActions.getBookInfo(classroom.id, task.bookId);

    const studentAttempt = getStudentAttemptData(task, user._id);
    const responses = studentAttempt.responses;
    let canStudentRepeatTask;
    if (studentAttempt.evaluation) {
      canStudentRepeatTask = studentAttempt.canStudentRepeat;
    }
    this.setState({
      commentMessageText:
        canStudentRepeatTask || responses.length === 0
          ? ''
          : (responses &&
              responses.length > 0 &&
              responses[responses.length - 1].data &&
              responses[responses.length - 1].data.commentMessageText) ||
            ''
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevProps.sendTaskDataIsSending && this.props.sendTaskDataIsSending) {
      this.onSendData();
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  closePanel = () => {
    const { drawerActions } = this.props;
    drawerActions.closeDrawerAndRemoveContent();
  };

  deleteResponseFile = (event, index) => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    const newFiles = [...this.state.responseFiles];
    newFiles.splice(index, 1);
    this.setState({
      responseFiles: newFiles
    });
  };

  onInputMessage = event => {
    const commentMessageText = event.target.value || '';
    const changeComment = !!event.target.value;
    this.setState({
      commentMessageText,
      changeComment
    });
  };

  closeTaskBySucces = () => {
    const { classroom, taskActions } = this.props;
    this.setState({ uploadingFile: false });
    this.onCancelButtonClick();
    let classroomId = classroom ? classroom.id : undefined;
    taskActions.getAllTasks(classroomId);
  };

  closeTaskByError = () => {
    this.setState({ uploadingFile: false });
    this.onCancelButtonClick();
  };

  onSendData = () => {
    const { assignmentsDrawerActions, task, user, classroom, taskActions, customer, dispatch } = this.props;
    const { commentMessageText, changeComment, responseFiles } = this.state;
    this.setState({ uploadingFile: true });

    const context = {
      userId: user._id,
      classroomId: classroom.id,
      customerId: customer.id,
      taskId: task.id
    };

    const onSuccess = () => {
      if (this.mounted) {
        this.setState({ uploadingFile: false });
        this.closeTaskBySucces();
      }
      dispatch(messageAlertActions.success(`${I18n.t('tasks.studentResponded')}`));
    };

    const onError = () => {
      this.setState({ uploadingFile: false });
      this.closeTaskByError();
      dispatch(messageAlertActions.error(`${I18n.t('tasks.studentErrorRespond')}`));
    };

    if (changeComment && responseFiles.length > 0) {
      assignmentsDrawerActions
        .submitTaskResponse(commentMessageText, responseFiles, context)
        .then(onSuccess)
        .catch(onError);
    } else if (changeComment) {
      assignmentsDrawerActions
        .submitCommentTaskResponse(commentMessageText, user._id, user.name, customer.id, task.id)
        .then(() => {
          taskActions.setTaskResponseComment(task.id, task, user);
          onSuccess();
        })
        .catch(onError);
    } else if (responseFiles.length > 0) {
      assignmentsDrawerActions
        .submitFreeAssignmentResponse(responseFiles, context)
        .then(onSuccess)
        .catch(onError);
    } else {
      this.setState({ uploadingFile: false });
    }
  };

  onSubmitButtonClick = () => {
    const { classroomActions } = this.props;
    classroomActions.setSubmitTaskModalState(true);
    classroomActions.sendTaskData(false);
  };

  onCancelButtonClick = () => {
    this.setState({ responseFiles: [] });
    this.closePanel();
  };

  renderHeader = () => {
    const { task } = this.props;

    if (task) {
      return (
        <div className="header header-assignments">
          <div className="title-assignments">
            <div className="close">
              <CustomIcon name="office-monthly-calendar" size={24} />
            </div>
            <span className="assignment-name">{task.name}</span>
          </div>
          <span className="assignment-due-date">
            {I18n.t('panels.assignment.dueDate')} {dayjs(task.dueDate).format('DD/MM/YYYY HH:mm')}
          </span>
        </div>
      );
    }
  };

  renderCommentContainer = () => {
    const { task, user } = this.props;

    const activities = task.activities.filter(activity => activity.activityType !== CMI5.ACTIVITY_TYPE.LESSON);

    const totalActivities = activities.length;
    const onTime = dayjs() < dayjs(task.dueDate);
    let result;
    let comment;
    let evaluatedBy;
    let canStudentRepeatTask = false;
    let isSecondTryWithoutEvaluation = false;
    if (task.studentAttempts && task.studentAttempts[user._id] && task.studentAttempts[user._id].evaluation) {
      canStudentRepeatTask = task.studentAttempts[user._id].canStudentRepeat;
      result = task.studentAttempts[user._id].evaluation.grade;
      comment = task.studentAttempts[user._id].evaluation.comment;
      evaluatedBy = task.studentAttempts[user._id].evaluation.updatedBy;
      isSecondTryWithoutEvaluation =
        task.studentAttempts[user._id].responses.length > 1 &&
        !task.studentAttempts[user._id].responses[task.studentAttempts[user._id].responses.length - 1].evaluation;
    }
    let allActivitiesDone =
      totalActivities && task.resultSummary && totalActivities === task.resultSummary[user._id].total;

    let showComment = !onTime || allActivitiesDone || !_.isNil(result);

    const grade = taskService.getTaskGrade(task, user._id);

    return (
      showComment &&
      !canStudentRepeatTask &&
      !isSecondTryWithoutEvaluation && (
        <CommentBox
          showCommentBox={grade !== null}
          comment={comment}
          userId={evaluatedBy ? evaluatedBy : task.teacherImage}
          grade={grade}
          title={I18n.t('panels.assignment.globalAssessment')}
        />
      )
    );
  };

  render() {
    const { user, evaluatedStudent, task, customer, book } = this.props;

    let showBookName = false;
    // If it has "bookActivityId" it means that it is a task associated with content
    if (task.bookActivityId && book && book.name) {
      showBookName = true;
    }

    const hideRow = this.state.responseFiles.length === 0 && !this.state.changeComment;

    const studentAttempt = getStudentAttemptData(task, user._id);
    const evaluatedStudentAttempt = getStudentAttemptData(task, evaluatedStudent._id);

    const canStudentRepeat = evaluatedStudentAttempt.canStudentRepeat;
    const studentHaveTwoAttempts = studentAttempt.responses.length > 1;
    const responses = studentAttempt.responses;
    const evaluation =
      studentHaveTwoAttempts && responses
        ? responses[responses.length - 1].evaluation
        : task.studentAttempts[user._id].evaluation;

    const showEvaluationFile = !!(evaluation && evaluation.attachments && evaluation.attachments.length);

    return (
      <div id="task-panel" className="task-panel">
        <div>
          {this.renderHeader()}
          {this.renderCommentContainer()}
          {showEvaluationFile && !canStudentRepeat && (
            <FileEvaluationBox task={task} student={evaluatedStudent} isFirstTry={false} />
          )}
          <ContentTaskContainer
            showTitle
            user={user}
            evaluatedStudent={evaluatedStudent}
            task={task}
            uploadingFile={this.state.uploadingFile}
            commentMessageText={this.state.commentMessageText}
            deleteResponseFile={(e, index) => this.deleteResponseFile(e, index)}
            onChangeFile={file =>
              this.setState(prevState => ({
                responseFiles: [...prevState.responseFiles, file]
              }))
            }
            onInputMessage={this.onInputMessage}
            isFirstTry={false} //
            book={showBookName && book}
          />
          {(canStudentRepeat || studentHaveTwoAttempts) && (
            <FirstEvaluationContainer task={task} user={user} customer={customer} />
          )}
        </div>
        <PanelsBottomRowButton
          hideRow={hideRow}
          disableButtons={this.state.uploadingFile}
          primaryButtonText={'common.submit'}
          showCancelButton={true}
          handlePrimaryButtonClick={this.onSubmitButtonClick}
          handleSecondaryButtonClick={this.onCancelButtonClick}
        />
      </div>
    );
  }
}

StudentTaskPanel.propTypes = {
  classroomActions: PropTypes.any,
  task: PropTypes.any,
  taskActions: PropTypes.any,
  bookActions: PropTypes.any,
  classroom: PropTypes.any,
  user: PropTypes.any,
  customer: PropTypes.object,
  responseFiles: PropTypes.any,
  drawerActions: PropTypes.any,
  assignmentsDrawerActions: PropTypes.any,
  evaluatedStudent: PropTypes.any,
  submitTaskDataIsOpen: PropTypes.bool,
  sendTaskDataIsSending: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    i18n: state.i18n,
    task: state.task.selectedTask,
    colors: state.theme.colors,
    emojis: state.theme.images.emojis,
    defaultIcon: state.theme.images.placeholders.attachmentIcon,
    user: state.account.user,
    customer: state.school.school.customer,
    classroom: state.classrooms.activeClassrooms.find(c => c.id === state.task.selectedTask.parentSection),
    avatarsImages: state.theme.images.avatars,
    evaluateFreeTask: state.account.configuration.evaluateFreeTask,
    evaluatedStudent: state.assignmentsDrawerActions.evaluatedStudent || state.account.user,
    submitTaskDataIsOpen: state.classrooms.submitTaskDataIsOpen,
    sendTaskDataIsSending: state.classrooms.sendTaskDataIsSending,
    role: state.classrooms.selectedClassroom.classroom.role,
    book: state.book.book
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomActions: bindActionCreators(classroomActions, dispatch),
    taskActions: bindActionCreators(taskActions, dispatch),
    drawerActions: bindActionCreators(drawerActions, dispatch),
    assignmentsDrawerActions: bindActionCreators(assignmentsDrawerActions, dispatch),
    bookActions: bindActionCreators(bookActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentTaskPanel);
